import { createActions } from 'redux-actions';

export const actions = createActions({
  FEED: {
    FILTER: type => type,
  },
}).feed;
